import React from 'react';
import {NavLink} from 'react-router-dom';

import Count from '../Count';
import {ReactComponent as BackIcon} from '../../../assets/icons/back-menu.svg';

import './Menu.scss';
import {IconButtonMUI} from '../../../shared';
import {useTranslation} from 'react-i18next';
import {useSelector} from "react-redux";

const Menu = ({
                  title,
                  menuList,
                  isYourContentVisible,
                  toggleYourContent,
                  back,
                  handleNavLinkClick,
                  additionalMenuItems = null,
                  disabled = false
              }) => {
    const {profileMe} = useSelector((state) => state.profile);
    const isFinancier = profileMe?.role === 'financier';

    const {t} = useTranslation();
    return (
        <div className='menu-components'>
            <>
                {!isYourContentVisible && back && (
                    <button onClick={toggleYourContent} className='menu-components__back'>
            <span>
              <BackIcon/>
            </span>
                        {back}
                    </button>
                )}
            </>

            <div className='menu-components__title'>{title}</div>

            <div className={`menu-components__list${disabled ? ' disabled' : ''}`}>
                {menuList.map(({name, icon, count, link, companiesChat, generalChat, notification}, index) => {
                        if(isFinancier && link === '/main/profile/user-notification') {
                            return  null
                        }
                        return  <NavLink to={link} key={index} className={`items`} onClick={handleNavLinkClick}>
                        <div className={`items__blocks`}>
                            {icon && <div className='items__icon'>{icon}</div>}
                            {name && <div className='items__name'>{name}</div>}
                            {count ? <div className='items__count'>{count}</div> : null}
                        </div>
                        <div className='items__blocks'>
                            {companiesChat && companiesChat > 0 ? (
                                <Count
                                    hasPlus={true}
                                    count={companiesChat}
                                    size={'xs'}
                                    color={'purple'}
                                    className={'items__companies-chat'}
                                />
                            ) : null}
                            {generalChat && generalChat > 0 ? (
                                <Count hasPlus={true} count={generalChat} size={'xs'} color={'green'}/>
                            ) : null}
                            {notification ? (
                                <>
                                    <IconButtonMUI color={'inherit'} className={'items__buttons'}
                                                   title={t('ProjectItems.notView')}>
                                        <Count count={notification} size={'xs'} color={'yellow'}/>
                                    </IconButtonMUI>
                                </>
                            ) : null}
                        </div>
                    </NavLink>
                }

                )}
                {additionalMenuItems}
            </div>
        </div>
    );
};

export default Menu;
